import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import TextInput from "../TextInput/TextInput";
import LogoWrapper from "../LogoWrapper/LogoWrapper";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useFont } from "../../contexts/FontContext/FontContext";
import axios from "axios";
import styles from "./Login.module.css";

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);
    const location = useLocation();
    const fontSchemes = useFont();    
    const fontFamilyOne = fontSchemes.scheme_one; 
    const navigate = useNavigate();

    useEffect(() => {
        // Extract the message from the URL query parameters
        const params = new URLSearchParams(location.search);
        const messageParam = params.get("message");
        if (messageParam) { setMessage(messageParam); }

        const checkAuthentication = async () => {
            const token = localStorage.getItem("authToken");
            if (token) { 
                const has_logistics_provider_code = localStorage.getItem("has_logistics_provider_code");
                if (has_logistics_provider_code) { navigate("/home_3pl"); }
                else { navigate("/home"); }
            } // Redirect if already logged in
        };
        checkAuthentication();    
    }, [location, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const requestData = {
            username: username,
            password: password
        };
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await axios.post(`${apiUrl}/api/login/`, requestData, {
                headers: {"Content-Type": "application/json"},
                withCredentials: true  // If your API needs credentials like cookies
            });
            if (response.status === 200) {
                const data = response.data;
                //console.log("Authentication successful", data);
                localStorage.setItem("authToken", data.access); // Store the authentication token in localStorage or cookie
                localStorage.setItem("refreshToken", data.refresh);
                localStorage.setItem("user", username);
                if (data.first_time_login) { navigate("/setup_integration_partner"); } // Redirect to integration partner setup page. Only Shopify for now
                else { 
                    if (data.has_logistics_provider_code) { 
                        localStorage.setItem("has_logistics_provider_code", true);
                        navigate("/home_3pl"); 
                    }
                    else { navigate("/home"); } // Redirect to normal home page 
                } 
            } else { setError("Invalid credentials. Please try again."); }
        } catch (error) {
            if (error.response && error.response.data) {
                console.log("Error data from server: ", error.response.data);
                setError(error.response.data.error || "An unknown error occurred.");
            } else { console.error("Error during authentication", error); }
        }
    };

    return (
        <div className={styles.login_container} onSubmit={handleSubmit}>
            <Helmet>
                <title>Log in</title>
            </Helmet>
            <LogoWrapper class_="login_logo" src={`${process.env.PUBLIC_URL}/images/logo.png`} />
            <p className={`titles ${styles.dashboard_login_title} ${fontFamilyOne}`}>Dashboard Login</p>
            {message && <p className={`error_message ${styles.thanks_for_confirming_message} ${fontFamilyOne}`}>{message}</p>}
            {error && (<p className="error_message">{error}</p>)}
            <form className={styles.login_form} onSubmit={handleSubmit}>
                <TextInput inputType={"username"} value={username} onChange={(e) => setUsername(e.target.value)} required error={false} />
                <TextInput inputType={"password"} value={password} onChange={(e) => setPassword(e.target.value)} required error={false} />
                <button className={`login_buttons ${styles.log_in} ${fontFamilyOne}`} type="submit">Log in</button>
            </form>
            <div className={styles.login_divider}>
                <hr className={styles.divider_line} />
                <span className={`${styles.divider_text} ${fontFamilyOne}`}>or</span>
                <hr className={styles.divider_line} />
            </div>
            <Link to="/signup" className={`login_buttons ${styles.sign_up} ${fontFamilyOne}`}>Sign up</Link>
            <Link to="/forgot_password" className={`${styles.divider_text} ${styles.forgot_password_link} ${fontFamilyOne}`}>Forgot Password?</Link>
        </div>
    );
};

export default Login;